import AppState, { SCREENS } from '@/js/AppState';
import Button from '@cmp/shared/Button/Button';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Texts from 'react-sdk/Texts';
import classes from './FirstCo.module.css';
import Select from 'react-select';
import Loader from "react-sdk/components/Loader/Loader";


const FirstCo = ({onDoneCB}) => {

  const [pseudo, setPseudo] = useState(AppState.vertxClient.UserData.getPseudo());
  const [group, setGroup] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(true);
  const [error, setError] = useState(null);


  const [options, setOptions] = useState([])

  useEffect(() => {
    AppState.getGroupList().then(groupList => {

      if (!AppState.debugMode)
        groupList = groupList.filter(v => v.enableRanking > 0)
      let options = groupList
        .sort((a, b) => {
          return a.teamPseudo.localeCompare(b.teamPseudo)
        })
        .map(v => {
          return { value : v.groupId, label : v.teamPseudo}
        });
      setOptions(options)
      setLoadingGroups(false)
    })
  }, []);

  // gestion de la connexion et passage à l'écran suivant
  function handleClick() {
    setLoading(true)

    if(pseudo !== AppState.vertxClient.UserData.getPseudo()) {
      AppState.vertxClient.UserUpdatePseudo(pseudo, (success, msg, data) => {
        if(success) {
          connectToGroup()
        } else {
          setLoading(false)
          setError("Le pseudo ne peut pas être modifié. (" + msg + ")")
        }
      })
    } else {
      connectToGroup()
    }

  }


  function connectToGroup() {
    AppState.vertxClient.GroupUserAdd(AppState.vertxClient.UserData.getUniverse(), group, AppState.vertxClient.UserData.getUserID(), (success, msg, data) => {
        if(success) {
          AppState.getUserTeamInfo()
            .then(() => AppState.connectToGlobalMeeting())
            .then(() => AppState.astekActivity.firstCo())
            .then(() => onDoneCB())

        } else {
          setLoading(false)
          setError("Le groupe ne peut pas être rejoint. (" + msg + ")")
        }
      })
  }


  function handleChangePseudo(e) {
    setPseudo(e.target.value)
  }
  function onGroupChange(val) {
    setGroup(val.value)
  }

  const selectStyles = {
    menu:(styles) => {
      return {
        ...styles,
      }
    },
    control: (styles) => {
      return {
        ...styles,
      }
    },
    placeholder: (styles) => ({
      ...styles,
      color: "#999999"
    }),
    indicatorSeparator: (styles) => {
      return { ...styles, display: 'none' }
    },
    dropdownIndicator: (styles) => {
      return {
        ...styles,
      }
    },
  };

  return (
      <div className={classes.FirstCo}>
      {/* <fieldset> */}
      <div>
        {/* <legend>{Texts.get("firstco-pseudo-title")}</legend> */}

        <label htmlFor='pseudo'>
          {Texts.get("firstco-pseudo-title")}
        </label>
        <input
        id="pseudo"
        disabled={loading || loadingGroups}
        placeholder={Texts.get("firstco-pseudo-placeholder")}
        name="pseudo"
        type="text"
        value={pseudo}
        onChange={handleChangePseudo}/>
      {/* </fieldset> */}
      </div>

      <div className={classes.text} dangerouslySetInnerHTML={{__html: Texts.get("firstco-group-descr") }}/>
      <fieldset>
        <legend>{Texts.get("firstco-group-title")}</legend>
        <div className={classes.Dropdown}>
          <Select

            options={options}
            isDisabled={loading || loadingGroups}
            onChange={onGroupChange}
            isSearchable={true}
            isClearable={false}
            placeholder={loadingGroups ? Texts.get("firstco-group-loading-placeholder") : Texts.get("firstco-group-placeholder")}
            styles={selectStyles}
            isLoading={loadingGroups}
          />
        </div>
      </fieldset>

      {error &&
      <div className={classes.error}>{error}</div>}

      <div className={classes.form_button_ctnr} >
        <Button
        disabled={loading || loadingGroups || pseudo == "" || group == ""}
        onClick={handleClick} >
          {Texts.get("firstco-btn-valid")}
        </Button>
      </div>


    </div>

  );
};

export default  observer(FirstCo)
